module.exports = __webpack_public_path__ + "static/media/arrow_back_on.da8d21dc.svg";